export default function LandingPage() {

  return (
    <div className="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column text-center">

      <main className="px-3">
        <h1>SUWA</h1>
        <p className="lead">
          Bienvenidos a la plataforma digital del curso. Por favor ingresa con la URL de la presentación directamente.
        </p>
      </main>
    </div>
  );
}
